// Inline SVG icon set.
//
// Emoji were standing in for icons across the site. They render as a
// different typeface on every OS (Apple's glossy set vs Google's flat vs
// Samsung's), they don't take the brand colour, they sit on the text
// baseline instead of aligning with it, and screen readers announce them by
// their Unicode name — "seedling", "money bag" — in the middle of a sentence.
//
// These are 24×24 stroke paths on the same grid, so they inherit
// currentColor and size with the surrounding text. Kept as a local map
// rather than an icon package: this is a couple of dozen glyphs and the
// site already ships every other icon as hand-written SVG.

const PATHS = {
  // — values / trust —
  sprout: 'M12 21v-8m0 0c0-3.314-2.686-6-6-6H4v2a6 6 0 006 6h2zm0 0c0-3.314 2.686-6 6-6h2v1a6 6 0 01-6 6h-2z',
  handshake: 'M15 20v-1a4 4 0 00-4-4H7a4 4 0 00-4 4v1M9 7.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM21 20v-1a4 4 0 00-3-3.87M16 3.63a4 4 0 010 7.75',
  shield: 'M12 3l7 3v5c0 4.4-2.9 8.4-7 9.7C7.9 19.4 5 15.4 5 11V6l7-3z',
  shieldCheck: 'M12 3l7 3v5c0 4.4-2.9 8.4-7 9.7C7.9 19.4 5 15.4 5 11V6l7-3zm-2.5 8.5l1.8 1.8 3.4-3.4',
  heartHands: 'M12 20s-6-4.2-6-8.2A3.3 3.3 0 0112 9.6a3.3 3.3 0 016 2.2c0 4-6 8.2-6 8.2z',
  check: 'M5 13l4 4L19 7',
  checkCircle: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
  lock: 'M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z',
  bolt: 'M13 10V3L4 14h7v7l9-11h-7z',
  arrowRight: 'M4 12h15m0 0l-6-6m6 6l-6 6',
  leaf: 'M4 20c0-8 5-13 15-14 1 9-3 15-11 15H4zm2-2c3-4 6-6 9-7',
  building: 'M4 21V7l8-4 8 4v14M9 21v-5h6v5M8 11h.01M12 11h.01M16 11h.01',
  chevronRight: 'M9 6l6 6-6 6',
  camera: 'M3 9a2 2 0 012-2h1.6l1.2-2h6.4l1.2 2H19a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V9zm9 9a4 4 0 100-8 4 4 0 000 8z',
  user: 'M12 12a4 4 0 100-8 4 4 0 000 8zm-7 8a7 7 0 0114 0',
  play: 'M12 21a9 9 0 100-18 9 9 0 000 18zm-1.5-12.5l5 3.5-5 3.5v-7z',
  briefcase: 'M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2m-13 0h18a1 1 0 011 1v11a2 2 0 01-2 2H4a2 2 0 01-2-2V8a1 1 0 011-1zm0 5h20',
  rupiah: 'M12 21a9 9 0 100-18 9 9 0 000 18zM9.5 16.5v-9H13a2.5 2.5 0 010 5H9.5m0 0H14',
  cap: 'M12 4L2 9l10 5 10-5-10-5zm-6 8v4.2c0 1.6 2.7 2.8 6 2.8s6-1.2 6-2.8V12',
  growth: 'M9 9a3 3 0 100-6 3 3 0 000 6zm-6 9a6 6 0 0112 0M17 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm4 7a5 5 0 00-4-4.9',
  badge: 'M12 3l2.2 1.6 2.7-.2.9 2.6 2.2 1.6-1 2.5 1 2.5-2.2 1.6-.9 2.6-2.7-.2L12 21l-2.2-1.6-2.7.2-.9-2.6L4 15.4l1-2.5-1-2.5 2.2-1.6.9-2.6 2.7.2L12 3z',
  idCard: 'M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm5 3.5a2 2 0 104 0 2 2 0 00-4 0zM6 16c.6-1.8 2.2-2.6 4-2.6s3.4.8 4 2.6M15 9h4M15 13h4',
  compass: 'M12 21a9 9 0 100-18 9 9 0 000 18zm3.5-12.5l-2 5.5-5.5 2 2-5.5 5.5-2z',
  calendarClock: 'M8 7V3m8 4V3M3 11h18M5 21h6M5 5h14a2 2 0 012 2v6M17 21a4 4 0 100-8 4 4 0 000 8zm0-5.2V17l1.4 1',
  book: 'M4 5a2 2 0 012-2h13v16H6a2 2 0 00-2 2V5zm2 12h13',
  moon: 'M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z',
  mirror: 'M12 3c3.3 0 6 3.6 6 8s-2.7 8-6 8-6-3.6-6-8 2.7-8 6-8zm0 16v2m-3 0h6',
  heartPulse: 'M12 20s-6-4.2-6-8.2A3.3 3.3 0 0112 9.6a3.3 3.3 0 016 2.2c0 4-6 8.2-6 8.2zM7 13h2.5l1-2 1.5 4 1-2H16',
  phoneRing: 'M15.5 20a12 12 0 01-11.5-11.5A2.5 2.5 0 016.5 6h1.8a1 1 0 011 .8l.7 2.6a1 1 0 01-.3 1l-1.2 1a10 10 0 004.1 4.1l1-1.2a1 1 0 011-.3l2.6.7a1 1 0 01.8 1v1.8a2.5 2.5 0 01-2.5 2.5z',
  signature: 'M3 17c3 0 3.5-9 6-9s2 9 4.5 9 2-5 4-5 2.5 2 3.5 2M3 21h18',
  folder: 'M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z',
  clipboard: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 8h6m-6 4h4',
  // — job meta —
  mapPin: 'M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z',
  wallet: 'M3 10h18M3 10a2 2 0 012-2h14a2 2 0 012 2M3 10v8a2 2 0 002 2h14a2 2 0 002-2v-8m-4 4h.01',
  clock: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
  calendar: 'M8 7V3m8 4V3M3 11h18M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
  // — states —
  warning: 'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z',
  plate: 'M12 3a9 9 0 100 18 9 9 0 000-18zm0 4a5 5 0 110 10 5 5 0 010-10z',
  // — SANTRI principles —
  handHeart: 'M21 11.5a8.4 8.4 0 01-9 8.4 9.9 9.9 0 01-2.6-.3L4 21l1.4-4.2A8.2 8.2 0 013 11.5C3 6.8 7 3 12 3s9 3.8 9 8.5z',
  scale: 'M12 3v18M5 7l-3 6h6l-3-6zm14 0l-3 6h6l-3-6zM3 21h18M7 7h10',
  home: 'M3 12l9-9 9 9M5 10v10a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1V10',
  humility: 'M12 4a3 3 0 110 6 3 3 0 010-6zM5 20c0-3.9 3.1-7 7-7s7 3.1 7 7',
  sparkle: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z',
  repeat: 'M4 9a5 5 0 015-5h9m0 0l-3-3m3 3l-3 3M20 15a5 5 0 01-5 5H6m0 0l3 3m-3-3l3-3',
};

export default function Icon({ name, className = 'w-5 h-5', strokeWidth = 1.8, ...rest }) {
  const d = PATHS[name];
  if (!d) return null;
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={d} />
    </svg>
  );
}
